module.exports = __webpack_public_path__ + "static/p20-e0eaae18d2a99e12080db3f92c8ed3c7.jpg";